import { render, staticRenderFns } from "./my-button.vue?vue&type=template&id=4d52d55d&scoped=true&"
import script from "./my-button.vue?vue&type=script&lang=js&"
export * from "./my-button.vue?vue&type=script&lang=js&"
import style0 from "./my-button.vue?vue&type=style&index=0&id=4d52d55d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d52d55d",
  null
  
)

export default component.exports